export default __webpack_public_path__ + "static/media/beach_1.aa5de590.jpg";